// extracted by mini-css-extract-plugin
export var button = "_dk-7";
export var buttonRow = "_dk-6";
export var fadeIn = "_dk-1";
export var gradient = "_dk-0";
export var panel = "_dk-2";
export var panelIn = "_dk-3";
export var subtitle = "_dk-5";
export var title = "_dk-4";